module.exports = __webpack_public_path__ + "img/intl-app-logo.3d4843f.webp";